import { Component, OnInit } from '@angular/core';
import { NgModule } from '@angular/core';
import { ShellComponent } from '../shell.component';
import { EmpleadomastServicio } from 'src/app/seguridad/seguridad/empleadomast.service';

@Component({
    selector: 'app-topbar',
    templateUrl: './app.topbar.component.html'
})
export class AppTopBarComponent implements OnInit {

    nombreCompleto: string = "";

    constructor(public app: ShellComponent, private empleadomastServicio: EmpleadomastServicio) { }

    ngOnInit() {
        this.empleadomastServicio.obtenerUsuarioActual().then(
            em => {
                this.nombreCompleto = em.personaNombreCompleto;
            }
        );
    }
}
